export const ModalRegisterTranslationsUk = {
  Registration: 'Реєстрація',
  Authorization: 'Авторизація',
  'Register with phone number or email':
    'Зареєструйтеся за допомогою номера телефону або електронної пошти',
  Email: 'Електронна пошта',
  'Phone Number': 'Номер телефону',
  Or: 'Або',
  Facebook: 'Facebook',
  Google: 'Google',
  Other: 'Інше',
};
